// @ts-nocheck

import { type BasketState } from '../../../states/basket';

const basketRemoveCachedMMAPIResponseInfos = (
  state: BasketState,
  action: {
    payload: {
      matchId: number;
    };
  },
) => {
  const { matchId } = action?.payload ?? {};

  if (typeof matchId === 'number' || typeof matchId === 'string') {
    const nextCache = { ...state.cachedMMAPIResponsesInfos };
    delete nextCache[matchId];

    return {
      ...state,
      cachedMMAPIResponsesInfos: nextCache,
    };
  }

  return state;
};

export default basketRemoveCachedMMAPIResponseInfos;
